export enum IntegrationCodeTypeEnum {
	Bodyshop = "1",
	Vehicle = "3",
	Part = "4",
	Insurer = "5",
	AssessmentType = "6",
	Make = "7",
	Model = "8",
	Submodel = "9",
	SupplierByBuyer = "10",
	Address = "11",
	InsuranceSubline = "12",
	ClaimFileCategory = "13",
	Valuator = "14",
	Supervisor = "15",
	Supplier = "16",
	ReasonTotalLoss = "17",
}
